import { Component, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';
import { CoreJssProxyModule } from '@core/jss-proxy';

@Component({
  selector: 'wl-funnel-content-container',
  templateUrl: './funnel-content.container.component.html',
  standalone: true,
  imports: [ContentSectionComponent, CoreJssProxyModule],
})
export class FunnelContentContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);
}
